import { ListAttributeTypesResponse } from '@cbinsights/userv2service/userv2service';
import { request } from 'client/modules/common/utils/request';

export const listTeamAttributeTypes = (): Promise<ListAttributeTypesResponse> =>
  request({
    url: '/service/userv2service/ListTeamAttributeTypes',
    body: {},
  }).then((r) => r.body);
